import React from 'react';

// Allegro "Problem z zakupem" (watek typu POST_PURCHASE_ISSUE w Centrum wiadomosci)
const PPI_LABELS: Record<string, string> = {
  PACKAGE_DELAYED: 'przesyłka opóźniona',
  PACKAGE_LOST: 'przesyłka zaginęła',
  NO_PRODUCT_IN_THE_SHIPMENT: 'brak produktu w przesyłce',
  SELLER_DOES_NOT_WANT_TO_ACCEPT_RETURN: 'sprzedający nie chce przyjąć zwrotu',
};
export const ppiLabel = (s?: string | null) => (s ? (PPI_LABELS[s] || s.toLowerCase().replace(/_/g, ' ')) : '');

export default function PpiBadge({ t, big }: { t: any; big?: boolean }) {
  if (!t || t.thread_type !== 'POST_PURCHASE_ISSUE') return null;
  const closed = t.thread_status === 'CLOSED';
  return (
    <span title={'Problem z zakupem' + (t.sub_type ? ': ' + ppiLabel(t.sub_type) : '') + (closed ? ' (zamknięty)' : '')}
      style={{ fontSize: big ? 12 : 10, padding: '1px 7px', borderRadius: 10, fontWeight: 600, whiteSpace: 'nowrap',
        background: closed ? '#f3f4f6' : '#fee2e2', color: closed ? '#6b7280' : '#b91c1c', border: '1px solid ' + (closed ? '#e5e7eb' : '#fecaca') }}>
      Problem
    </span>
  );
}

export function PpiOrder({ t }: { t: any }) {
  if (!t || t.thread_type !== 'POST_PURCHASE_ISSUE' || !(t.ok_order_number || t.order_ref)) return null;
  const v = t.ok_order_number || t.order_ref;
  return (
    <span title="Kliknij aby skopiować numer zamówienia" onClick={e => { e.stopPropagation(); try { navigator.clipboard.writeText(v); } catch (er) {} }}
      style={{ fontSize: 12, color: '#374151', cursor: 'copy' }}>
      Zamówienie: <b style={{ fontFamily: 'monospace' }}>{v}</b>
    </span>
  );
}

const plain = (s: string) => {
  try { return (new DOMParser().parseFromString(String(s || '').replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n'), 'text/html').body.textContent || '').trim(); }
  catch (e) { return String(s || ''); }
};

// Wiadomosc Allegro (chatbot / system) w watku Problemu z zakupem
export function AllegroSystemMessage({ m }: { m: any }) {
  const d = m && m.createdAt ? new Date(m.createdAt).toLocaleString('pl-PL', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';
  const role = m && m.author ? m.author.role : '';
  return (
    <div style={{ marginBottom: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 3 }}>Allegro{role === 'CHATBOT' ? ' · wiadomość automatyczna' : role === 'SYSTEM' ? ' · informacja systemowa' : ''} · {d}</div>
      <div style={{ maxWidth: '85%', padding: '9px 13px', borderRadius: 12, fontSize: 13, lineHeight: 1.6, background: '#fff7ed', color: '#7c2d12',
        border: '1px solid #fed7aa', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{plain(m && m.text)}</div>
    </div>
  );
}
